import { ReactElement } from 'react';

import AllIcon from 'assets/images/notificationCategories/all.svg?react';
import ApplicationsIcon from 'assets/images/notificationCategories/applications.svg?react';
//import ChangesOffersIcon from 'assets/images/notificationCategories/changesOffers.svg?react';
import ChangesCapsIcon from 'assets/images/notificationCategories/changesCaps.svg?react';
import JoinedOffersIcon from 'assets/images/notificationCategories/joinedOffers.svg?react';
/*import LimitsIcon from 'assets/images/notificationCategories/limits.svg?react';
import TrafficIcon from 'assets/images/notificationCategories/traffic.svg?react';
import PromotionsIcon from 'assets/images/notificationCategories/promotions.svg?react';
import SystemIcon from 'assets/images/notificationCategories/system.svg?react';*/
import OtherIcon from 'assets/images/notificationCategories/other.svg?react';
import RejectedOffersIcon from 'assets/images/notificationCategories/rejectedOffers.svg?react';
import { i18n } from 'i18n';
import { EDefaultOptions } from 'shared/typings';

export const NOTIFICATIONS_CATEGORIES: Record<string, { name: string; icon: ReactElement }> = {
	[EDefaultOptions.ALL]: {
		name: i18n.t('All Categories'),
		icon: <AllIcon />,
	},
	['applications']: {
		name: i18n.t('Applications'),
		icon: <ApplicationsIcon />,
	},
	['joined-offers']: {
		name: i18n.t('Joined offers'),
		icon: <JoinedOffersIcon />,
	},
	['rejected-offers']: {
		name: i18n.t('Rejected offers'),
		icon: <RejectedOffersIcon />,
	},
	/*changes_offers: {
    name: i18n.t('Changes in Offers rules and terms'),
    icon: <ChangesOffersIcon />,
  },*/
	['changes-in-caps-and-mmp-links']: {
		name: i18n.t('Changes in CAPs and MMP links '),
		icon: <ChangesCapsIcon />,
	},
	/*limits: {
    name: i18n.t('Required adjustments: reaching the limits'),
    icon: <LimitsIcon />,
  },
  traffic: {
    name: i18n.t('Traffic quality'),
    icon: <TrafficIcon />,
  },
  promotions: {
    name: i18n.t('Promotions'),
    icon: <PromotionsIcon />,
  },
  system: {
    name: i18n.t('System updates'),
    icon: <SystemIcon />,
  },*/
	others: {
		name: i18n.t('Others'),
		icon: <OtherIcon />,
	},
};
